import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-not-found-with-image',
  templateUrl: './not-found-with-image.component.html',
  styleUrls: ['./not-found-with-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundWithImageComponent implements OnInit {
  @Input() title = '404';
  @Input() description = '404';
  @Input() imgPath: string = null;
  constructor() {}

  ngOnInit() {}
}
